<template>
  <!--
  Using the Bulma Card class as Tile to avoid confusion with credit cards.
   -->
  <div
    class="tile card"
    :tabindex="enabled ? 0 : ''"
    :class="{
      'tile--focusable': focusable && !disabled,
      'tile--selected': selected && !disabled,
      'tile--disabled': disabled,
      [`tile--${type}`]: true
    }"
    @keyup="onKeyUp"
    @click="onClick"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    focusable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "is-primary"
    }
  },
  computed: {
    enabled() {
      return this.focusable && !this.disabled;
    }
  },
  methods: {
    onClick(event) {
      if (this.enabled) {
        this.$emit("click", event);
      }
    },
    onKeyUp(event) {
      // Send the 'click' event on spacebar or enter key presses.
      if ((this.enabled && event.keyCode == 32) || event.keyCode == 13) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "bulma/sass/utilities/mixins.sass";
@import "@/scss/colors.scss";

@mixin active-color($active-color) {
  &.tile--focusable {
    &:active {
      box-shadow: 0 2px 3px rgba($active-color, 0.5), 0 0 0 1px $active-color;
    }
  }
  &.tile--selected {
    &,
    &:hover,
    &:focus {
      box-shadow: 0 2px 3px rgba($active-color, 0.5), 0 0 0 1px $active-color;
    }
  }
}

.tile {
  align-items: center;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  width: 100%;
  &--focusable {
    cursor: pointer;
    &:hover,
    &:focus {
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
        0 0 0 1px rgba(10, 10, 10, 0.3);
      outline: none;
    }
    &:active {
      outline: none;
    }
  }
  &--disabled {
    box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.05);
  }
  &--is-primary {
    @include active-color($primary);
  }
  &--is-info {
    @include active-color($info);
  }
  &--is-danger {
    @include active-color($danger);
  }
  &--is-success {
    @include active-color($success);
  }
}
</style>
